import { cva } from 'class-variance-authority';

export const panelVariants = cva(
  'bg-surface border border-subtle rounded-panel shadow-sm',
  {
    variants: {
      padding: {
        default: 'px-4 py-5 sm:p-6',
        compact: 'py-4 sm:py-6 px-4 sm:px-6',
        none: '',
      },
      overflow: {
        visible: 'overflow-visible',
        hidden: 'overflow-hidden',
      },
    },
    defaultVariants: {
      padding: 'default',
      overflow: undefined,
    },
  }
);

export const panelClasses = panelVariants({ padding: 'default' });

export const tablePanelClasses = panelVariants({ padding: 'none', overflow: 'hidden' });
